import WebGLBackground from './WebGLBackground';
import NoiseOverlay from './NoiseOverlay';
import useMagneticCursor from '../hooks/useMagneticCursor';
import useParallax from '../hooks/useParallax';

const VisualEffects = ({ children }) => {
  // Initialize cursor and parallax effects
  useMagneticCursor();
  useParallax();

  return (
    <>
      {/* WebGL shader background at z-index 0 */}
      <WebGLBackground />
      
      {/* Noise grain overlay at z-index 1 */}
      <NoiseOverlay />
      
      {/* Main content */}
      {children}
    </>
  );
};

export default VisualEffects;
